import type { AxiosError } from 'axios';
import type { RefetchFunction } from 'axios-hooks';
import { createContext } from 'react';
import type { ErrorEnvelop } from '../../hooks';
import type { Users } from '../../interfaces';

export interface usersContext {
  dataUsers: Users[] | undefined;
  loadingUsers: boolean;
  errorUser: AxiosError<ErrorEnvelop, unknown> | null;
  getUsers: RefetchFunction<unknown, unknown>;
}

export const UsersContext = createContext<usersContext | undefined>(undefined);
